import styled from "styled-components";

const EmptyContainer = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export default EmptyContainer;